import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { useMutation, useManualQuery, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import PlaylistAddCheckCircleOutlinedIcon from '@mui/icons-material/PlaylistAddCheckCircleOutlined';

import styled from "styled-components";

import penImg from "../../assets/icons/pen.png";
import trashImg from "../../assets/icons/trash.png";
import previewImg from "../../assets/icons/preview.png";
import publishImg from "../../assets/icons/publish.png";
import unpublishImg from "../../assets/icons/unpublish.png";

import PeopleIcon from "@mui/icons-material/People";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";

import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";
import {
  STAFF_CLIENT_LIST_QUERY,
} from "../../graphQL/client_qry";
import {
  GET_USER_DATA_BY_USERNAME,
} from "../../graphQL/register_qry";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";

import { project_url } from "../../constants/Data";

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    height: "870px",
    backgroundColor: "#ffffff",
  },
  ComponentDragBox: {
    float: "left",
  },
  FormDropBox: {
    float: "left",
    marginLeft: "5rem",
    marginTop: ".5rem",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
}));

function UserGroups() {
  const [loadData, setLoadData] = useState(false);
  const [loadContent, setLoadContent] = useState(false);
  const { userId } = useParams();

  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);

  const [tenantClientList, setTenantClientList] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const tenantName = localStorage.getItem("tenantName");
  const tenantId = localStorage.getItem("tenantId");

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  let clientName = "";
  if (localStorage.getItem("clientName")) 
    clientName = localStorage.getItem("clientName");

  const [groupsAccess, setGroupsAccess] = useState(true);


  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Staff",
              modulepageName: "List"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {         
            
      let commonActions = accessData.staffModuleAccess.additionalActions.split('|');      
      
      if(commonActions.find(a => a == "Groups")){
        setGroupsAccess(true);}
      else {
        setGroupsAccess(false);
      }     
      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  const classes = useStyles();

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = day => {
    const dayDate = new Date(day);
    const dayFormat = formatter.formatToParts(dayDate);
    const newFormat =
      dayFormat.find(a => a.type == "month").value +
      "/" +
      dayFormat.find(a => a.type == "day").value +
      "/" +
      dayFormat.find(a => a.type == "year").value;
    return newFormat;
  };

  const [fetchStaffClientList] = useManualQuery(STAFF_CLIENT_LIST_QUERY, {
    fetchPolicy: "network-only",
  });

  const [getUserDataByUserName] = useManualQuery(GET_USER_DATA_BY_USERNAME, {
    fetchPolicy: "network-only",
  });
  
  useEffect(() => {
    (() => getUserData())();
  }, [userId]);
  
  const getUserData = async () => {
    // Get user information
    const {
      loading: userDataLoading,
      error: userDataError,
      data: userData,
    } = await getUserDataByUserName({
      variables: { username: userId },
    });

    if (userData && !userData.getUserDataByUsername) {
      navigate(`${project_url}/tenant/dashboard`);
    } else if (
      userData &&
      userData.getUserDataByUsername &&
      userData.getUserDataByUsername == null
    ) {
      navigate(`${project_url}/tenant/dashboard`);
    } else if (!userDataLoading && userData && userData.getUserDataByUsername) {
      setLoadContent(true);
      setFirstName(userData.getUserDataByUsername.firstName);
      setLastName(userData.getUserDataByUsername.lastName);
    }

    if (
      userDataError &&
      userDataError.graphQLErrors &&
      userDataError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin`);
    }
  };

  const getClientsList = async () => {
    const {
      loading: clientsListLoading,
      error: clientsListError,
      data: clientsListData,
    } = await fetchStaffClientList({
      variables: { username: userId }
    });

    if (!clientsListLoading && clientsListData && clientsListData.staffClientList) {
      setTenantClientList(clientsListData.staffClientList);
      setLoadData(true);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getClientsList())();
  }, []);


  const columns = [
    {
      field: "name",
      headerName: "Client",
      minWidth: 170,
      flex: 1,
      //sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "termNoOfWeeks",
      headerName: "Term No of Weeks",
      minWidth: 120,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "termStartDate",
      headerName: "Term Start Date",
      minWidth: 120,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "groups",
      headerName: "Group(s)",
      minWidth: 120,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (rows) => (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%', textAlign: 'center' }}>
          {rows.row.groups.map((group, index) => (
            <div key={index}>
              <StyledTooltip title="Configure group permissions">
                <Box>
                  {group.name}
                  <PlaylistAddCheckCircleOutlinedIcon 
                    style={{
                      cursor: "pointer",
                      height: 18,
                      weight: 18,
                      marginLeft: 10,
                      marginBottom: "-4px"
                    }}
                    onClick={() => navigate(`${project_url}/staff/${userId}/groups/${group.groupUuid}/group-permissions`)}
                  />
                </Box>
              </StyledTooltip>
            </div>
          ))}
        </div>
      ),
    },
  ];

  var rows = tenantClientList.map(client => ({
    id: client.client.clientId,
    clientUuid: client.client.clientUuid,
    name: client.client.name,
    termNoOfWeeks: client.client.termNoOfWeeks,
    termStartDate: dayFormat(client.client.termStartDate),
    groups: client.groups
  }));

  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 5,
            paddingBottom: 6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={10} style={{ textAlign: "center" }}>
            <Typography variant="h1" style={{ fontSize: 20, paddingLeft: 100 }}>
              Staff in Groups
            </Typography>
          </Grid>
        </Grid>
        <Divider />
      </>
    );
  }
  
  if (loadContent && loadData)
  if (groupsAccess)
    return (
      <div className={classes.root}>
        <Header breadcrumbs={[{ label: firstName + " " + lastName, link: null },
                              { label: 'Groups', link: null}]} />
        <div className={classes.container} style={{ marginTop: 21 }}>
          <DataGrid
            className={classes.dataGridStyle}
            columns={columns}
            rows={rows}
            getRowHeight={() => 'auto'}
            showCellRightBorder={true}
            hideFooter={true}
            slots={{
              toolbar: DataGridTitle,
            }}
            getRowId={row => row.id}
            autoHeight={true}
            experimentalFeatures={{ newEditingApi: true }}
            initialState={{
              sorting: {
                sortModel: [{ field: "name", sort: "asc" }],
              },
            }}
          />
        </div>
      </div>
    );
  
  else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default UserGroups;
